module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_kinney_sm-899a1c9c1bc550f87e06397c2848dd39.png";